import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";

type ClearMode = "TP" | "NON_TP";

interface ConfirmTabChangeModalProps {
  open: boolean;
  clearMode: ClearMode;
  onConfirm: () => void;
  onCancel: () => void;

  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

const ConfirmTabChangeModal: React.FC<ConfirmTabChangeModalProps> = ({
  open,
  clearMode,
  onConfirm,
  onCancel,
  title = "Cambiar de pestaña",
  confirmLabel = "Sí, cambiar",
  cancelLabel = "Cancelar",
}) => {
  const dialogBody =
    clearMode === "TP"
      ? "Si cambias de pestaña, se limpiará toda la selección realizada en Técnico Profesional (especialidad, nivel y asignatura)."
      : "Si cambias de pestaña, se limpiará la selección realizada (nivel y asignatura).";

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      BackdropProps={{
        sx: { backgroundColor: "rgba(29, 61, 77, 0.6)" },
      }}
      PaperProps={{
        sx: {
          backgroundColor: "#ffffff",
          borderRadius: 2,
          padding: 0,
          minWidth: 320,
          fontFamily: "'Montserrat', sans-serif",
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontFamily: "'Montserrat', sans-serif",
          fontWeight: "bold",
          color: "#336B87",
          fontSize: 18,
          px: 3,
          pt: 3,
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent sx={{ px: 3, pb: 2 }}>
        <DialogContentText
          sx={{
            color: "rgba(0,0,0,0.6)",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: 14,
            textAlign: "center",
          }}
        >
          {dialogBody}
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onCancel}
          variant="text"
          sx={{
            backgroundColor: "#FFFFFF",
            color: "#FB3748",
            textTransform: "none",
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 600,
            borderRadius: 2,
            "&:hover": {
              backgroundColor: "#FB3748",
              color: "#FFFFFF",
            },
          }}
        >
          {cancelLabel}
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: "#336B87",
            color: "#FFFFFF",
            textTransform: "none",
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 600,
            borderRadius: 2,
            ml: 1,
            "&:hover": {
              backgroundColor: "#1FC16B",
              color: "#FFFFFF",
            },
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmTabChangeModal;
export type { ClearMode };
